'use strict';
import angular from 'angular';
import CheckoutProcessTabsController from './checkout-process-tabs.controller';
import CartService from '../../app/cart/cart.service';
export default angular.module('eeComUiApp.checkoutProcessTabs', [])
    .service('CartService', CartService)
    .component('checkoutProcessTabs', {
    template: require('./checkout-process-tabs.html'),
    controller: CheckoutProcessTabsController
})
    .name;
//# sourceMappingURL=index.js.map